import React from 'react';
import { Link } from 'gatsby';

import {
	DescriptionWithImage,
	PaddingContainer,
	WidthContainer,
} from '@components';
import EmbeddedSoftwareImage from '@static/images/figures/embedded-software.webp';
import ZebraCaseStudyImage from '@static/images/figures/zebra-case-study.webp';
import { PageUrls } from '@utils/constants/PageUrls';

import * as styles from './LookingForMore.module.scss';

export const LookingForMore: React.FC = () => {
	return (
		<div>
			<PaddingContainer className="white-bg pb-0">
				<WidthContainer>
					<h2 className="font-size-medium-title">Looking for more? </h2>
				</WidthContainer>
			</PaddingContainer>
			<DescriptionWithImage
				imageClassName={styles.image}
				disableContentPadding
				imageOnRight
				image={EmbeddedSoftwareImage}
			>
				<div className="font-size-sm line-height-26 limit-text">
					<p className="font-size-md font-600 mb-2">
						Embedded Software Development.
					</p>
					<p>
						We need to program what we created. The device should have some
						special purpose. Our job is to make it work as the project assumes.
						Why is this process important? Some of the built devices will help
						to collect data. This whole logic is responsible for the program and
						each application is different.{' '}
						<span className="font-600">
							The device is controlled from the outside
						</span>
						. There is always something somewhere that needs to be adjusted,
						configured, and parameters selected. It works on a lower level than
						the operating system which is why it is a necessary step in building
						the whole project.
					</p>
					<p className="font-size-md font-600 mb-2 mt-4">
						From idea to production.
					</p>
					<p>
						We start with a concept. We need to make sure that the product we
						have in mind will actually offer a potential solution. We care about
						design. The designers try to meet the client’s expectations and
						connect the vision with functionality. Engineering and prototyping
						are very important steps, so our specialists put emphasis on this
						stage.
					</p>
					<p className="font-size-md font-600 mb-2 mt-4">PCB</p>
					<p>
						We do not forget about{' '}
						<span className="font-600">the hardware</span>. We create PCB -
						Printed Circuit Board. It is a block of most modern electronic
						devices. It is a board with lines and pads connecting various points
						together. Our Embedded Engineers create PCB for particular IoT
						projects. One implementation that contains PCB is an active
						pedestrian crossing with an intelligent system with motion sensors
						for EUROASFALT.
					</p>
				</div>
			</DescriptionWithImage>
			<DescriptionWithImage
				className="gray-bg"
				imageClassName={styles.zebraImage}
				image={ZebraCaseStudyImage}
				imageOnRight
			>
				<p className="font-size-small-title mb-3 font-600">
					Active pedestrian crossing
				</p>
				<p className="font-size-sm mb-4">
					ZEBRA is an active pedestrian crossing which has a feature of
					informing a driver about pedestrians at crossings. APC Zebra is in
					sync with motion sensors, active road studs, road signs with warning
					lamps and an anti-skid system. Crossings are intended to protect the
					pedestrian when he or she is at or near the crossing. APC system does
					not run continuously but only activates when necessary.
				</p>
				<Link
					to={PageUrls.ZEBRA_CASE_STUDY}
					className="bttn bttn-orange-border link"
				>
					See full case study
				</Link>
			</DescriptionWithImage>
		</div>
	);
};
